export const GET_LIST = 'getList'
export const SET_LIST = 'setList'
export const SET_LIST_LOADING = 'setListLoading'
export const SET = 'set'
export const SET_RECORD_LOADING = 'setRecordLoading'
export const READ = 'read'